import { render, staticRenderFns } from "./NumberingSetup.vue?vue&type=template&id=38faed06&"
import script from "./NumberingSetup.vue?vue&type=script&lang=js&"
export * from "./NumberingSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports